import propTypes from 'prop-types';
import * as S from './styles';

const containersByLayout = {
  list: { List: S.StepList, Item: S.StepItem },
  grid: { List: S.StepGrid, Item: S.StepCard },
};

const StepCards = ({ steps, variant, layout, compact }) => {
  const { List, Item } = containersByLayout[layout] || containersByLayout.list;

  return (
    <List $compact={compact}>
      {steps.map((step, index) => (
        <Item key={step.title} $compact={compact}>
          <S.StepNumber $variant={variant}>{index + 1}</S.StepNumber>
          <S.StepContent>
            <S.StepTitle>{step.title}</S.StepTitle>
            <S.StepText>{step.text}</S.StepText>
          </S.StepContent>
        </Item>
      ))}
    </List>
  );
};

StepCards.propTypes = {
  steps: propTypes.arrayOf(
    propTypes.shape({
      title: propTypes.string.isRequired,
      text: propTypes.string.isRequired,
    }),
  ).isRequired,
  variant: propTypes.oneOf(['info', 'success', 'danger']),
  layout: propTypes.oneOf(['list', 'grid']),
  compact: propTypes.bool,
};

StepCards.defaultProps = {
  variant: 'info',
  layout: 'list',
  compact: false,
};

export default StepCards;
